import * as React from 'react';
import isEmpty from 'lodash/isEmpty';

import { useSelector } from '~/renderer/store';
import { getCfdOptions } from '~/renderer/store/cfd/selectors';
import { getIsActive, getSale } from '~/renderer/store/receipt/selectors';

import CompletedSale from '../CompletedSale';
import { ReceiptWrapper } from './Receipt.style';
import ReceiptCustomer from './ReceiptCustomer';
import ReceiptGuestBarcode from './ReceiptGuestBarcode';
import ReceiptHeader from './ReceiptHeader';
import ReceiptTable from './ReceiptItemsTable';
import ReceiptSummary from './ReceiptSummary';

export const Receipt: React.FunctionComponent = () => {
  const sale = useSelector(getSale);
  const isActive = useSelector(getIsActive);
  const options = useSelector(getCfdOptions);
  const saleLines = sale?.SaleLines?.SaleLine || [];
  const { completed: isCompleted = false, ticketNumber = null } = sale || {};
  const hasUntaxedItems =
    (options.isUntaxedItemNoteVisible &&
      !!saleLines.find(saleLine => saleLine.tax === false && isEmpty(saleLine.workOrder))) ||
    false;
  const firstName = options.isCustomerNameVisible ? sale?.Customer?.firstName : undefined;

  if (isEmpty(sale))
    return <ReceiptWrapper isActive={false} isCompleted={false} data-testid="receipt-no-sale" />;

  return (
    <ReceiptWrapper data-testid="receipt-wrapper" isActive={isActive} isCompleted={isCompleted}>
      {isCompleted ? (
        <CompletedSale sale={sale} isCompleted={isCompleted} firstName={firstName} />
      ) : (
        <>
          <ReceiptHeader />
          <ReceiptCustomer firstName={firstName} />
          <ReceiptTable saleLines={saleLines} hasUntaxedItems={hasUntaxedItems} />
          <ReceiptSummary hasUntaxedItems={hasUntaxedItems} sale={sale} />
          <ReceiptGuestBarcode
            isCompleted={isCompleted}
            ticketNumber={ticketNumber}
            firstName={firstName}
          />
        </>
      )}
    </ReceiptWrapper>
  );
};

export default Receipt;
